import React from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

const PrivacyPolicy = () => {
  return (
    <div className="p-1 flex justify-center">
      <Card className="w-full shadow-4">
        <h2 className="text-center text-2xl font-bold mb-1">Privacy Policy</h2>
        <p>We value your privacy. This policy explains what data we collect, how we use it, and how we protect it.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Information We Collect</h5>
        <p>We collect:
          <ul>
            <li><strong>Personal Data:</strong> Name, email, phone number, and address when you register or interact with us.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, and site activity.</li>
          </ul>
        </p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">How We Use Your Information</h5>
        <p>Your data helps us:
          <ul className="flex gap-6">
            <li>Manage your account.</li>
            <li>Process transactions.</li>
            <li>Enhance site functionality.</li>
            <li>Provide customer support.</li>
          </ul>
        </p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Security & Children’s Privacy</h5>
        <p>We take reasonable steps to protect your data. We do not knowingly collect information from children under 13.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Updates & Contact</h5>
        <p>We may update this policy periodically. Questions? Contact us at <a href="mailto:ask@chinmmaisystemss.com">ask@chinmmaisystemss.com</a>.</p>
      </Card>
    </div>
  );
};

const TermsOfService = () => {
  return (
    <div className="p-4 flex justify-center">
      <Card className="w-full shadow-4">
        <h2 className="text-center text-2xl font-bold mb-4">Terms of Service</h2>
        <p>By using our website, you agree to our terms.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Intellectual Property</h5>
        <p>All content on this site is owned or licensed by us and is protected by law.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">User Responsibilities</h5>
        <p>Users must provide accurate information and comply with our terms.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Prohibited Activities</h5>
        <p>Do not misuse the site, collect unauthorized data, or engage in fraudulent activity.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Governing Law</h5>
        <p>These terms are governed by the laws of India.</p>
        <Divider />
        <h5 className="text-base font-semibold mb-1">Contact Us</h5>
        <p>For inquiries, contact us at <a href="mailto:ask@chinmmaisystemss.com">ask@chinmmaisystemss.com</a>.</p>
      </Card>
    </div>
  );
};

export { PrivacyPolicy, TermsOfService };
